<lib-status-chip
    class="statuses"
    [status]="status">
</lib-status-chip>
